import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
const sources = [{
  title: 'First Round Capital',
  description: '300 companies, 600 founders over 10 years',
  citation: '10 Year Project (2015)',
  link: 'https://10years.firstround.com/'
}, {
  title: 'Gallup Research',
  description: 'Manager impact on engagement & retention',
  citation: 'State of the Workplace (2015)',
  link: 'https://news.gallup.com/businessjournal/182792/managers-account-variance-employee-engagement.aspx'
}, {
  title: 'Harvard Business School',
  description: "Noam Wasserman's study of 10,000 founders",
  citation: "The Founder's Dilemmas (2012)",
  link: 'https://www.hbs.edu/faculty/Pages/item.aspx?num=42425'
}, {
  title: 'UNSW & Oxford',
  description: '21,000+ founder personality profiles analyzed',
  citation: 'Scientific Reports (2023)',
  link: 'https://www.unsw.edu.au/newsroom/news/2023/10/founder-personality-could-predict-start-up-success--study'
}, {
  title: 'Yael Daniely',
  description: '400+ founders on co-founder relationship dynamics',
  citation: 'Founder Study (2019-2021)',
  link: 'https://yaeldaniely.com/2023/09/09/unspoken-yet-lethal-dysfunctional-co-founders-relationships/'
}, {
  title: 'WinSavvy',
  description: 'Founder conflicts and startup failure correlation',
  citation: 'Founder Research',
  link: 'https://www.winsavvy.com/founder-conflicts-and-startup-failure-correlation-stats-you-should-know/'
}];
export function ResearchFoundationSection() {
  return <section id="research-foundation" className="px-4 sm:px-8 md:px-[60px] py-[100px] bg-white" data-id="element-1132">
      <div className="max-w-[1400px] mx-auto" data-id="element-1133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-1134">
          <div className="inline-flex items-center px-4 py-2 rounded bg-[#1A3D3A] text-white mb-8" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '12px',
          fontWeight: 600,
          letterSpacing: '3px',
          lineHeight: 1.0,
          borderRadius: '4px'
        }} data-id="element-1135">
            RESEARCH FOUNDATION
          </div>
          <h2 className="text-[#1A3D3A]" style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: 'clamp(40px, 5vw, 56px)',
          fontWeight: 500,
          lineHeight: 1.1,
          letterSpacing: '-1px'
        }} data-id="element-1136">
            Grounded in Peer-Reviewed Evidence
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-[24px]" data-id="element-1137">
          {sources.map((source, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-[#F8FAF9] rounded-[12px] p-8 text-center" style={{
          boxShadow: '0 8px 40px rgba(26, 61, 58, 0.1)'
        }} data-id="element-1138">
              <h3 className="text-[#1A3D3A] mb-4" style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: '24px',
            fontWeight: 500,
            lineHeight: 1.3
          }} data-id="element-1139">
                {source.title}
              </h3>
              <p className="text-[#3D5654] mb-4" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '15px',
            fontWeight: 400,
            lineHeight: 1.6
          }} data-id="element-1140">
                {source.description}
              </p>
              <p className="text-[#1A3D3A] mb-4" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '13px',
            fontWeight: 600
          }} data-id="element-1141">
                {source.citation}
              </p>
              <a href={source.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#1A3D3A] hover:opacity-70 transition-opacity" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '13px',
            fontWeight: 500
          }} data-id="element-1142">
                <ExternalLink className="w-4 h-4" data-id="element-1143" />
                View Research
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}